module.exports = __webpack_public_path__ + "img/map_Z5.4.D.09.8bbcee87.svg";